import { ILoggedInDetails } from '@Interface/Login';
import { AppServices } from './appSlice';
import { Dispatch, PayloadAction } from '@reduxjs/toolkit';
// import { IRewardPoints } from '@Interface/Home';


export const dispatchLoggedInDetails = (payload: ILoggedInDetails) => (
    dispatch: Dispatch<PayloadAction<ILoggedInDetails>>
) => {
    dispatch(AppServices.actions.storeLoggedInDetails(payload));
};

export const dispatchSelectedMenu = (payload: string) => (
    dispatch: Dispatch<PayloadAction<string>>
) => {
    dispatch(AppServices.actions.storeSelectedMenu(payload));
};

export const dispatchDatalayers = (payload: any) => (
    dispatch: Dispatch<PayloadAction<any>>
) => {
    dispatch(AppServices.actions.storeDatalayers(payload));
};